import { FC, memo, useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Box, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StorageService } from "@dfl/react-security";

type LanguageMenuProps = {
  icon: any,
  component: any,
  options: any[]
}

export const LANGUAGE_INPUT = 'dfl_input_lang'

const LanguageMenu: FC<LanguageMenuProps> = ({ component = Link, icon, options }) => {
  const { t } = useTranslation("locales");
  const [anchorEl, setAnchorEl] = useState(null);
  const [locale, setLocale] = useState<string | null>(null)
  const open = Boolean(anchorEl);

  useEffect(() => {
    const input = StorageService.getItem(LANGUAGE_INPUT)
    if (input) {
      const lang = options?.find(op => op === input)
      if (lang) {
        setLocale(lang)
      }
    }
  }, [options])

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguageHandler = (lng: string) => {
    StorageService.setItem(LANGUAGE_INPUT, lng)
    setLocale(lng)
    handleClose();
  };

  const Component = component;

  return (
    <Box>
      <Component
        id="language-selector"
        aria-controls={open ? "language-input-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {icon} {t(locale ? `${t('input')} (${locale.toUpperCase()})` : t('input'))}
      </Component>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "language-selector",
        }}
      >
        {
          options?.map(op => (<MenuItem
            onClick={() => changeLanguageHandler(op)}
            key={op}
            selected={anchorEl === op}
          >
            {String(op).toUpperCase()}
          </MenuItem>))
        }
      </Menu>
    </Box>
  );
};

export default memo(LanguageMenu);
